/** Crisp pixel-art image used for item icons on cards. */
export const PixelArt = ({
  src,
  alt,
  size,
  className = "",
  style,
}: {
  src: string;
  alt: string;
  size: number;
  className?: string;
  style?: React.CSSProperties;
}) => (
  <img
    src={src}
    alt={alt}
    className={className}
    style={{ width: size, height: size, imageRendering: "pixelated", ...style }}
    draggable={false}
  />
);
